import React, { useState } from "react";
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap";
import Loader from "../common/Spinner";
import godrejDarkLogo from "../../assets/images/godrej.svg";
import { verifyAccessCode } from "../../services/user-service";

const AccessCodeVerification = ({ userData, setAccessCodeVerified, onBack }) => {
  const [accessCode, setAccessCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!accessCode.trim()) {
            setError("Please Enter the Commercial Legal Website Access Code");
            return;
        }

        setLoading(true);
        setError("");
        try {
            // Add Access code verification API call here
            console.log("Verifying Access code:", accessCode);
            let codeObj = {
                UserId: userData.UserId,
                MobileNo: userData.MobileNo,
                AccessCode: accessCode
            }
            let result = await verifyAccessCode(codeObj);
            if (result?.valid) {
                setAccessCodeVerified(true);
            }
            else {
                setAccessCodeVerified(false);
                setError(result.message);
            }
        } catch (err) {
            setError("Invalid access code. Please try again.");
        }
        setLoading(false);
    };

  return (
    <>
      {loading && <Loader />}
      
      {/* Header - Same as Login */}
      <div className="d-flex logoHeader">
        <img src={godrejDarkLogo} alt="Godrej Enterprise Logo" />
        <span className="headerLink">Godrej Enterprises Group</span>
      </div>

      {/* Access code Verification Content - Centered */}
      <Container fluid className="accesscode-container">
        <Row className="justify-content-center align-items-center h-100">
          <Col xs={12} sm={8} md={6} lg={4}>
            <Card className="accesscode-card shadow">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <h2 className="accesscode-title">Commercial Legal Website</h2>
                  <p className="accesscode-subtitle">Access Code Verification</p>
                </div>

                <Form onSubmit={handleSubmit}>
                  <div className="text-center mb-4">
                    <p className="accesscode-instruction">
                      Please Enter the Commercial Legal Website Access Code that you will receive / received on your mobile
                    </p>
                  </div>

                  {error && (
                    <div className="accesscode-error mb-3">
                      <div className="accesscode-error-header">Verification Failed</div>
                      <div className="accesscode-error-body">{error}</div>
                    </div>
                  )}

                  <div className="mb-4">
                    <Form.Label className="accesscode-label">Access Code:</Form.Label>
                    <Form.Control
                      type="text"
                      value={accessCode}
                      maxLength={6}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setAccessCode(value);
                      }}
                      placeholder="Enter access code"
                      autoComplete="off"
                      className="accesscode-input"
                      size="lg"
                    />
                  </div>

                  <div className="d-grid mb-3">
                    <Button 
                      type="submit"
                      variant="success"
                      className="accesscode-submit-btn"
                      disabled={loading}
                      size="lg"
                    >
                      {loading ? "Verifying..." : "Submit"}
                    </Button>
                  </div>

                  {onBack && (
                    <div className="text-center">
                      <Button 
                        variant="link" 
                        onClick={onBack}
                        className="accesscode-back-btn"
                      >
                        Back to Login
                      </Button>
                    </div>
                  )}
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AccessCodeVerification;